import { keyframes } from 'styled-components';

export const Expand = keyframes`
  0%{
    opacity: 0;
    transform: scaleY(0);
    transform-origin: 100% 0%;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: 100% 0%;
  }
`;
